import Mediator from 'mediator-js'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import {
  WINDOW_DID_SCROLL,
  WINDOW_WAS_RESIZED,
  BREAKPOINT_CHANGE,
} from 'srcReact/helpers/events/types'
import { getMq } from 'srcReact/helpers/utils'

class Manager {
  constructor() {
    this.mq = getMq()
    this.mediator = new Mediator()
    this.bind()
  }

  bind() {
    this.throttledScrollHandler = throttle((e) => {
      this.mediator.publish(WINDOW_DID_SCROLL, e)
    }, 10)
    window.addEventListener('scroll', this.throttledScrollHandler, false)

    this.throttledResizeHandler = debounce((e) => {
      const newMq = getMq()
      if (this.mq !== newMq) {
        this.mediator.publish(BREAKPOINT_CHANGE, {
          newBreakpoint: newMq,
          oldBreakpoint: this.mq,
        })
        this.mq = newMq
      }
      this.mediator.publish(WINDOW_WAS_RESIZED, e)
    }, 20)
    window.addEventListener('resize', this.throttledResizeHandler, false)
  }

  unbind(e) {
    window.removeEventListener(e)
  }

  publish = (channel, e) => {
    this.mediator.publish(channel, e)
  }

  subscribe = (channel, cb) => {
    this.mediator.subscribe(channel, cb)
  }

  unsubscribe = (channel, cb) => {
    this.mediator.remove(channel, cb)
  }
}

export default new Manager()
